import axios from "axios";
import store from "@/store";
import {AREA_LABELS} from "@/utils/constants";

const translatePlayerRoles = (data) => {
	if (Array.isArray(data)) data.forEach(translatePlayerRoles);
	else if (data && Object.getPrototypeOf(data) === Object.prototype) {
		for (const [key, value] of Object.entries(data)) {
			const roleField =
				["primaryRole", "secondaryRole", "roleSnapshot"].includes(key) ||
				(key === "role" && data.participationId && data.playerId);
			if (roleField && typeof value === "string")
				data[key] = AREA_LABELS[value] || value;
			else if (value && typeof value === "object") translatePlayerRoles(value);
		}
	}
	return data;
};

const createAxiosInstanceWithAuthInterceptor = () => {
	const instance = axios.create({
		headers: {
			"Content-Type": "application/json",
		},
	});

	instance.interceptors.request.use(
		(config) => {
			const token = store.getState().token;
			if (token && config.useAuthInterceptor) {
				config.headers.Authorization = `Bearer ${token}`;
			}
			return config;
		},
		(error) => {
			return Promise.reject(error);
		},
	);

	instance.interceptors.response.use((response) => {
		response.data = translatePlayerRoles(response.data);
		return response;
	});
	return instance;
};

const api = createAxiosInstanceWithAuthInterceptor();

export default api;
